// Anything quick and dirty that needs thrown in but you will tidy/optimize later
$('#datenanhang-file-upload').on('change', function ()
{
    var file = $('#datenanhang-file-upload')[0].files[0].name;

    $(this).parent().parent().find('span.name').find('p').remove();
    $(this).parent().parent().find('span.name').append('<p>: ' + file + '</p>');
});
